module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/il-empty-state-ub.0fe615c5.svg";